import { adjust } from "./util"
import meshTable from '../assets/meshTable'

/** Module de conversion d'unités
 * Ce module doit contenir l'ensemble des unités de conversion
 * et les formules pour convertir dans les 2 sens
 * cf: https://www.gordonengland.co.uk/conversion/flowrate.htm  (FLOW RATE)
 * cf: http://metricconversion.biz/fr/conversion-1-hertz-en-tourparheure-frequence.html (FREQUENCY)
 * cf: http://www.theonlineconverter.co.uk/speed-converter/  (SPEED)
 */

const TYPES = ["Length", "Pressure", "Volume", "Energy", "Flow rate", "Temperature", "Mass", "Frequency", "Speed", "Mesh size"] // Tableau contenant les types de conversion (exemple : Longueur est un type de conversion)
const UNITS = [
    { name: "kilometer", value: 0.001, type: "Length" },
    { name: "meter", value: 1, type: "Length" },
    { name: "centimeter", value: 100, type: "Length" },
    { name: "millimeter", value: 1000, type: "Length" },
    { name: "micrometer", value: 1000000, type: "Length" },
    { name: "nanometer", value: 1000000000, type: "Length" },
    { name: "inch", value: 39.37, type: "Length" },
    { name: "mile", value: 0.000621371, type: "Length" },
    { name: "yard", value: 1.09361296, type: "Length" },
    { name: "foot", value: 3.281, type: "Length" },
    { name: "bar a", value: 1, type: "Pressure" },
    { name: "mbar a", value: 1000, type: "Pressure" },
    { name: "atmosphere", value: 0.986923, type: "Pressure" },
    { name: "pascal", value: 100000, type: "Pressure" },
    { name: "psi", value: 14.5038, type: "Pressure" },
    { name: "mmHg/Torr", value: 750.062, type: "Pressure" },
    { name: "mWC", value: 10.332275548, type: "Pressure" },
    { name: "mmWC", value: 10332.275548, type: "Pressure" },
    { name: "joule", value: 1, type: "Energy" },
    { name: "kilojoule", value: 0.001, type: "Energy" },
    { name: "kilocalorie", value: 0.000239006, type: "Energy" },
    { name: "calorie (th)", value: 0.2390057361, type: "Energy" },
    { name: "BTU", value: 9.478672985781991e-4, type: "Energy" },
    { name: "Wh", value: 0.000277778, type: "Energy" },
    { name: "kWh", value: 2.7778e-7, type: "Energy" },
    { name: "m³/s", value: 1, type: "Flow rate" },
    { name: "m³/min", value: 60, type: "Flow rate" },
    { name: "m³/h", value: 3600, type: "Flow rate" },
    { name: "L/s", value: 1000, type: "Flow rate" },
    { name: "L/min", value: 6e4, type: "Flow rate" },
    { name: "L/h", value: 3600000, type: "Flow rate" },
    { name: "cm³/h", value: 3600000000, type: "Flow rate" },
    { name: "US gallon/s", value: 0.003785, type: "Flow rate" },
    { name: "US gallon/h", value: 1.0515e-6, type: "Flow rate" },
    { name: "UK gallon/s", value: 219.96920000000003, type: "Flow rate" },
    { name: "UK gallon/min", value: 1.319815e4, type: "Flow rate" },
    { name: "UK gallon/h", value: 791889.2, type: "Flow rate" },
    { name: "UK ft³/s", value: 35.31466, type: "Flow rate" },
    { name: "UK ft³/min", value: 2118.8799999999997, type: "Flow rate" },
    { name: "UK ft³/h", value: 1.271328e5, type: "Flow rate" },
    { name: "degree celsius", type: "Temperature" },
    { name: "kelvin", type: "Temperature" },
    { name: "fahrenheit", type: "Temperature" },
    { name: "kilogram", value: 1, type: "Mass" },
    { name: "gram", value: 1000, type: "Mass" },
    { name: "tonne", value: 0.001, type: "Mass" },
    { name: "milligram", value: 1e6, type: "Mass" },
    { name: "Pound", value: 2.205, type: "Mass" },
    { name: "oz", value: 35.274, type: "Mass" },
    { name: "hertz", value: 1, type: "Frequency" },
    { name: "kilohertz", value: 0.001, type: "Frequency" },
    { name: "megahertz", value: 1e-6, type: "Frequency" },
    { name: "gigahertz", value: 1e-9, type: "Frequency" },
    { name: "turn/s", value: 1, type: "Frequency" },
    { name: "turn/min", value: 60, type: "Frequency" },
    { name: "turn/h", value: 3600, type: "Frequency" },
    { name: "meter/s", value: 1, type: "Speed" },
    { name: "km/h", value: 3.6, type: "Speed" },
    { name: "mile/h", value: 2.23694, type: "Speed" },
    { name: "ft/s", value: 3.280839895, type: "Speed" },
    { name: "ft/min", value: 196.850393701, type: "Speed" },
    { name: "ft/h", value: 11811.023622047, type: "Speed" },
    { name: "inch/s", value: 39.37007874, type: "Speed" },
    { name: "inch/min", value: 2362.204724409, type: "Speed" },
    { name: "inch/h", value: 141732.283464567, type: "Speed" },
    { name: "yard/s", value: 1.093613298, type: "Speed" },
    { name: "yard/min", value: 65.6167979, type: "Speed" },
    { name: "yard/h", value: 3937.007874016, type: "Speed" },
    { name: "L", value: 1, type: "Volume" },
    { name: "centilitre", value: 100, type: "Volume" },
    { name: "millilitre", value: 1000, type: "Volume" },
    { name: "m³", value: 0.001, type: "Volume" },
    { name: "UK Galon", value: 0.219969, type: "Volume" },
    { name: "UK Quart", value: 0.879877, type: "Volume" },
    { name: "UK oz", value: 35.1951, type: "Volume" },
    { name: "ft³", value: 0.0353147, type: "Volume" },
    { name: "inch³", value: 61.0237, type: "Volume" },
    { name: "US Galon", value: 0.264172, type: "Volume" },
    { name: "US Quart", value: 1.05669, type: "Volume" },
]  // Tableau contenant les unités ainsi que leur type et la valeur de conversion, ce tableau possède {name, value, base, type}

/** Renvoi l'ensemble des types de conversion possibles */
export const getTypes = () => {
    return TYPES
}

/** Fonction permettant de récupérer l'ensemble des unités d'un type */
export const findUnitsByTypes = (type) => {
    return UNITS.filter(unit => unit.type === type)
}

/** Fonction permettant de récupérer une unité par nom */
export const findUnitByName = (name) => {
    return UNITS.find(unit => unit.name === name)
}

/** Fonction de conversion générique
 */
export const convert = (val, unit1, unit2) => {
    let result = 0
    switch (unit1.type) {
        case "Temperature":
            result = convertTemperature(val, unit1, unit2) // on délègue à la fonction de conversion spécifique
            break
        case "Mesh size":
            result = convertMesh(unit1.name, val) // on délègue à la fonction de conversion spécifique
            break
        default:
            result = val * unit2.value / unit1.value
            break
    }
    return adjust(result, 3)
}

/** Fonction spécifique de conversion des températures 
 * Cette fonction est non-générique
*/
const convertTemperature = (val, unit1, unit2) => {
    if (unit1.name === "kelvin" && unit2.name === "fahrenheit") {
        return (val - 273.15) * 9 / 5 + 32
    }
    else if (unit1.name === "kelvin" && unit2.name === "degree celsius") {
        return val - 273.15
    }
    else if (unit1.name === "fahrenheit" && unit2.name === "kelvin") {
        return (val - 32) * 5 / 9 + 273.15
    }
    else if (unit1.name === "fahrenheit" && unit2.name === "degree celsius") {
        return (val - 32) * 5 / 9
    }
    else if (unit1.name === "degree celsius" && unit2.name === "fahrenheit") {
        return (val * 9 / 5) + 32
    }
    else if (unit1.name === "degree celsius" && unit2.name === "kelvin") {
        return val + 273.15
    }
}

/** Fonction spécifique de conversion de mesh
 * cette fonction est non-générique
 * Elle utilise un tableau de valeurs "meshtable" réalisé à partir des valeurs fournies par Thomas
 */
const convertMesh = (from, val) => {
    try {
        switch (from) {
            case 'US':
                const meshUS = meshTable.find(m => m["US"] === val)
                return meshUS["mm"]
            case 'mm':
                const meshMM = meshTable.find(m => m["mm"] === val)
                return meshMM["US"]
            default:
                break
        }
    } catch (err) {
        throw new Error('Wrong value')
    }
}

/** Fonction permettant de récupérer les valeurs par défaut */
export const findMeshUnits = () => {
    return meshTable
}